import { useForm } from "@core/features/form";
import { useResetPassword } from "@core/features/auth";
import { usePlatformStore } from "@platform/store";
import { ResetPasswordForm } from "./ResetPasswordForm";

type Props = {
  /** Firebase oobCode from URL params */
  oobCode: string;
  onError?: () => void;
  onSuccess?: () => void;
  /** Render prop for custom actions (submit button, etc.) */
  renderActions?: (props: {
    isSubmitting: boolean;
    isValid: boolean;
    isSuccess: boolean;
    onSubmit: () => Promise<void>;
  }) => React.ReactNode;
};

export function ResetPasswordFormContainer({
  oobCode,
  onError,
  onSuccess,
  renderActions,
}: Props) {
  const clearAuth = usePlatformStore((s) => s.clearAuth);

  const handleError = () => {
    clearAuth();
    onError?.();
  };

  const { resetPasswordMutation, isSuccess, schema, defaultValues } =
    useResetPassword({
      oobCode,
      onError: handleError,
      onSuccess,
    });

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: resetPasswordMutation.mutateAsync,
    defaultValues,
  });

  const { isSubmitting, isValid } = form.formState;

  return (
    <>
      {!isSuccess && <ResetPasswordForm form={form} />}
      {renderActions?.({
        isSubmitting,
        isValid,
        isSuccess,
        onSubmit: handleSubmit,
      })}
    </>
  );
}

export default ResetPasswordFormContainer;
